import { render, staticRenderFns } from "./TbMedal.vue?vue&type=template&id=55bbf258&"
import script from "./TbMedal.vue?vue&type=script&lang=js&"
export * from "./TbMedal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports